export const SCHEDULE_C_DATA = {
  STEPS: {
    STEP_1: 1,
    STEP_2: 2,
    STEP_3: 3,
    STEP_4: 4,
  },
  TEXTS: {
    PAGE_HEADER: 'Schedule C',
    STEP_1: {
      TITLE: 'Please read carefully before we start',
      DISCLAIMER: 'DISCLAIMER:',
      TEXT: 'Important information regarding the Schedule C report provided by Lili:\n'
        + '- The report provided by Lili can be used to assist with your tax preparations.\n'
        + '- The report is taking into account all the income reported to your Lili account.\n'
        + '- Excluding parts of your income from the Schedule C report is your responsibility.\n'
        + '- The report provided by Lili is not taking into account your returns and allowances, cost of goods sold, other income not reported to your Lili account (Federal and state gasoline or fuel tax credit or refunds) and expenses related to your vehicle.\n'
        + '- (Optional - written in other reports) Final categorization of income and expenses for tax purposes is your responsibility.\n'
        + '- Lili is not a tax preparer and tax related questions should be directed to the IRS. ',
      TEXT_LINK: 'https://www.irs.gov/',
      BUTTON: 'Get Started',
    },
    STEP_2: {
      UNDER_MONEY_TEXT: 'NET INCOME',
      FREELANCE_HINT_1: 'Freelance Income?',
      FREELANCE_HINT_2: '(Total of your 1099s)',
      FREELANCE_PLACEHOLDER: 'Freelance',
      PAYROLL_HINT_1: 'Other Income?',
      PAYROLL_HINT_2: '(W2 income, friends & family...)',
      PAYROLL_PLACEHOLDER: 'Payroll',
      SUB_TITLE: 'Reporting your income',
      TEXT: 'The Schedule C captures the income you received for your freelance work only (1099 forms). You need to remove all income from jobs where your employer filed a W2 on your behalf, as well as personal, friends and family transfers. Only income received to your Lili account can be reported here.',
      BUTTON: 'Next',
    },
    POPUP: {
      TITLE: 'Just one last thing',
      TEXT_1: 'We see that you donated $',
      TEXT_2: ' last year. This expanses are not reported in Schedule C so you should download the file from the IRS site and submit it',
      BUTTON: 'OK',
    },
    STEP_4: {
      TITLE: 'You’re all done!',
      SUB_TITLE: 'Alright, let\'s take a look!',
      TEXT: 'Schedule C reports can be used to assist with your tax preparation. Final categorization of income and expenses for tax purposes is your responsibility.\n'
        + 'Lili is not a tax preparer and tax related questions should be directed to the IRS. Home | Internal Revenue Service.',
      BUTTON: 'Generate Schedule C Form',
    },
  },
};
